// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal--modal--3-gld","preventClickOutside":"Modal--prevent-click-outside--s-SOr","fixed":"Modal--fixed--3CPPq","full":"Modal--full--1tOdi"};